import React, { useEffect, useState } from 'react'
import { useNavigate, createSearchParams } from 'react-router-dom'
import './index.css'
import { useTranslation } from 'react-i18next'
import { Mask } from 'antd-mobile'
import CommonUtil from '../../utils/CommonUtil'

const helpItems = [
    { title: 'login_item_no_vercode', type: 'vercode' },
    { title: 'login_item_login_failed', type: 'login_failed' },
    { title: 'login_item_forget_pwd', type: 'forget_pwd' },
]

const LoginHelpMain = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const [concatDlgVisible, setConcatDlgVisible] = useState(false)
    const [wechatDlgVisible, setWechatDlgVisible] = useState(false)
    const handleOnClick = (item) => {
        navigate({
            pathname: '/login_help_detail',
            search: createSearchParams({
                type: item.type
            }).toString()
        })
    }

    const handleOnCancat = () => {
        setConcatDlgVisible(true)
    }

    const handleOnPhoneClick = () => {
        window.ReactNativeWebView.postMessage('400-069-0588')
    }

    const handleOnWechatClick = () => {
        setConcatDlgVisible(false)
        setWechatDlgVisible(true)
    }

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('single_help'))
        }
    }

    useEffect(postTitle, [])

    return <div className='App'>
        {
            helpItems.map((item, index) => {
                return <div key={index.toString()} className='item' onClick={() => {
                    handleOnClick(item)
                }}>
                    <span style={styles.itemText}>{t(item.title)}</span>
                    <img src={`${CommonUtil.getSourceDomain()}item_next_img.png`} alt='' style={styles.itemIcon} />
                </div>
            })
        }
        <>
            <Mask visible={concatDlgVisible} onMaskClick={() => setConcatDlgVisible(false)}
                color='#00000066'>
                <div className='cancatContent'>
                    <div style={styles.dlgTitle}>
                        <span style={{ fontSize: 15, color: '#000000', fontWeight: '500' }}>{t('cancat')}</span>
                        <div style={{ position: 'absolute', top: 19, right: 15, width: 32, height: 32 }}
                            onClick={() => setConcatDlgVisible(false)}>
                            <img src={`${CommonUtil.getSourceDomain()}modal_close.png`} alt='' style={{ width: 32, height: 32 }} />
                        </div>
                    </div>
                    <span style={{ height: 6 }} />
                    <div className='cancatContentItem' onClick={handleOnPhoneClick}>
                        <img src={`${CommonUtil.getSourceDomain()}help_phone.png`} alt='' style={{ width: 40, height: 40, marginLeft: 20 }} />
                        <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                            <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('cancat_phone')}</span>
                            <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('phone_num')}</span>
                            <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time')}</span>
                        </div>
                    </div>
                    <span style={{ height: 14 }} />
                    <div className='cancatContentItem' onClick={handleOnWechatClick}>
                        <img src={`${CommonUtil.getSourceDomain()}help_wechat.png`} alt='' style={{ width: 40, height: 40, marginLeft: 20 }} />
                        <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                            <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('wechat')}</span>
                            <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('wechat_account')}</span>
                            <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time1')}</span>
                        </div>
                    </div>
                </div>
            </Mask>
            <div className='cancat' onClick={handleOnCancat}>
                <span style={styles.cancat}>{t('cancat')}</span>
            </div>
        </>

        <>
            <Mask visible={wechatDlgVisible} onMaskClick={() => setWechatDlgVisible(false)}
                color='#00000066'>
                <div className='wechatContent'>
                    <img src={`${CommonUtil.getSourceDomain()}wechat_qr_image.png`} alt='' style={{ width: 130, height: 130 }} />
                    <div style={{ fontSize: 14, color: '#373150', marginTop: 5 }}>{t('wechat') + ': ' + t('wechat_account')}</div>
                    <div style={{ height: 1, width: '100%', background: '#E5E5E5', marginTop: 28 }} />
                    <div style={{ fontSize: 16, color: '#7F56FF', fontWeight: '500', marginTop: 15 }}
                        onClick={() => setWechatDlgVisible(false)}>{t('btn_sure')}</div>
                </div>
            </Mask>
            <div className='cancat' onClick={handleOnCancat}>
                <span style={styles.cancat}>{t('cancat')}</span>
            </div>
        </>

    </div>
}

const styles = {
    itemText: {
        marginLeft: 15,
        color: '#000000CC',
        fontSize: 14,
        fontWeight: '500'
    },
    itemIcon: {
        width: 24,
        height: 24,
        marginRight: 15
    },
    cancat: {
        fontSize: 15,
        color: '#4C4C4CCC',
        fontWeight: '500'
    },
    dlgTitle: {
        display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', height: 50, marginTop: 10
    }
}

export default LoginHelpMain